import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CmsTournamentPodiumBlock } from "@/gen/realtime";

export const TournamentPodiumForm = ({
    block,
    setBlock,
}: {
    block: CmsTournamentPodiumBlock;
    setBlock: (mutate: (block: CmsTournamentPodiumBlock) => void) => void;
}) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle>Tournament Podium</CardTitle>
                <CardDescription>Displays the top 3 finishers of a tournament.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <div className="space-y-2">
                    <Label htmlFor="tournament-id">Tournament ID (Optional)</Label>
                    <Input
                        id="tournament-id"
                        type="text"
                        value={block.otherTournamentId || ""}
                        onChange={e => {
                            const value = e.target.value.trim();
                            setBlock(draft => {
                                draft.otherTournamentId = value || null;
                            });
                        }}
                        placeholder="Leave empty to use container's tournament"
                    />
                    <p className="text-muted-foreground text-xs">
                        If not specified, will use the tournament from the context. Use this to show
                        podiums from other tournaments (e.g., "Last year's winners").
                    </p>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="title">Title (Optional)</Label>
                    <Input
                        id="title"
                        type="text"
                        value={block.title || ""}
                        onChange={e => {
                            const value = e.target.value.trim();
                            setBlock(draft => {
                                draft.title = value || null;
                            });
                        }}
                        placeholder="e.g., 'Tournament Winners' or 'Last Year's Podium'"
                    />
                    <p className="text-muted-foreground text-xs">
                        Optional custom title for additional context. Typically used when showing
                        podiums from other tournaments.
                    </p>
                </div>
            </CardContent>
        </Card>
    );
};
